const PARTNERS = [
  "Rajasthan Tourism",
  "Incredible India",
  "IIM Udaipur",
  "START",
  "Startup Rajasthan",
  "RKCL",
];

export default function Partners() {
  return (
    <section className="border-t border-slate-100 bg-white py-12">
      <div className="container-page">
        <h3 className="text-center font-display text-lg font-semibold text-navy-900">
          Trusted By Our Partners
        </h3>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {PARTNERS.map((p) => (
            <span
              key={p}
              className="text-sm font-semibold uppercase tracking-wide text-slate-400"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
